<script setup lang="ts">
interface LabeledSwitchProperties {
  id: string;
  label: string;
  disabled?: boolean;
  size?: 's' | 'm';
}

withDefaults(defineProps<LabeledSwitchProperties>(), { size: 's' });

const model = defineModel<boolean>({ default: false });
</script>

<template>
  <UiLabel
    :for="id"
    :class="
      cn(
        'group -m-1.5 flex h-11 items-center gap-2 rounded px-1.5 py-2 transition',
        disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer hover:bg-gray-50',
      )
    "
  >
    <UiSwitch
      :id="id"
      v-model="model"
      :disabled="disabled"
      :class="cn(size === 'm' ? 'h-6 w-11' : 'h-5 w-9', 'transition', disabled && 'data-[state=checked]:bg-gray-300')"
      :thumb-class="
        size === 'm' ? 'h-5 w-5 data-[state=checked]:translate-x-5' : 'h-4 w-4 data-[state=checked]:translate-x-4'
      "
    />
    <span :class="cn('min-w-0 flex-1 font-normal', size === 'm' ? 'text-sm' : 'text-xs')">{{ label }}</span>
  </UiLabel>
</template>
